export default function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-trigger/node_modules/rc-util/es/Dom/canUseDom.js
// module id = 616
// module chunks = 0